import { createContext, JSX, ReactNode, useContext } from 'react';
import { usePortalBranding, PortalBranding } from 'vopay';

export const BrandingContext = createContext<PortalBranding>({
  primaryColor: '',
  secondaryColor: '',
  logo: '',
  smallLogo: '',
  appTitle: '',
  setBrandingValues: () => {},
});

type BrandingProviderProps = {
  children: ReactNode;
};

export const BrandingContextProvider = ({ children }: BrandingProviderProps): JSX.Element => {
  const portalBranding = usePortalBranding('VoPay Account Portal');

  return <BrandingContext.Provider value={portalBranding}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
